<template>
    <div class="justify-content-center mb-5">

        <div class="row justify-content-center">
            <div class="col-md-5 my-4">
                <p class="fts-20 light-white-03 text-center font-weight-bold">Sélectionnez un de vos contrats pour accéder aux titres que nous recommandons ce mois-ci</p>
                 <select
                    class="form-control-4"
                    style="font-size:11px; width: 100%; text-transform: capitalize;"
                    v-model="alternative">
                    <option value="null" disabled>Vos contrats</option>
                    <option v-for="(alternative, index) in alt_array" :key="index" :value="alternative">{{ alternative.contract.name }} {{ alternative.platform.name }}</option>
                </select>
            </div>
        </div>

        <table class="mx-auto text-center h-emphasis my-5 fts-14" style="width:100%;">
            <colgroup>
                <col style="width: 25%;">
                <col style="width: 25%;">
                <col style="width: 25%;">
                <col style="width: 25%;">
            </colgroup>
            <thead>
                <tr class="m-emphasis" style="font-weight: bold; border-bottom: 1px solid rgba(255, 255, 255, .88); border-top: 1px solid rgba(255, 255, 255, .88);">
                    <!--<th></th>-->
                    <th>Secteur recommandé par myfo</th>
                    <th>Les titres que vous pourriez acheter dans ce secteur</th>
                    <th class="text-left p-3">Pourquoi nous conseillons ce secteur ?</th>
                    <th>Horizon de placement suggéré</th>
                </tr>
            </thead>
            <tbody class="text-center" style="overflow: auto;">
                <tr v-for="(rec, index) in alternative.recommendations" :key="index" style="border-bottom: 1px solid rgba(255, 255, 255, .12);">
                    <!--<td class="py-3 px-2" style="vertical-align: middle;">
                        {{ rec.scanner_recommendation_id }}
                    </td>-->
                    <td class="py-3 px-2" style="vertical-align: middle;">
                        <!--<span style="padding: 5px; background-color: rgba(99, 91, 255, .1); border-radius: 50%;" class="mr-2">
                            {{ rec.scanner_recommendation_id }}
                        </span>-->
                        <span class="light-blue-01 font-weight-bold">{{ rec.sector.name_french }}</span>
                    </td>
                    <td v-if="rec.alternatives_empty == 0" class="py-3 px-2" style="vertical-align: middle;">
                        <div v-for="(alt, index2) in alternative.recommendations[index].alternatives" :key="index2">
                            <div class="h-emphasis font-weight-bold">
                                {{ alt.name }}
                            </div>
                            <div class="fts-12 m-emphasis py-2">
                                ISIN : {{ alt.isin }}
                            </div>
                            <div class="fts-12 m-emphasis py-2">
                                Frais : {{ alt.fees }}
                            </div>
                        </div>
                    </td>
                    <td v-else class="py-3 px-2" style="vertical-align: middle;">
                        <div v-if="alternative.recommendations[index].alternatives_boursorama.length != 0">
                            <div v-for="(alt_fortuneo, index3) in alternative.recommendations[index].alternatives_fortuneo" :key="index3">
                                <div class="h-emphasis font-weight-bold">
                                    {{ alt_fortuneo.name }}
                                    <button style="background-color: transparent; border: none;" class="h-emphasis" v-b-modal="modalId(infoalternative)">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="mb-1 bi bi-info-circle" viewBox="0 0 16 16">
                                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                            <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                                        </svg>
                                    </button>
                                    <b-modal
                                        title="Ce titre est disponible sur une autre plateforme d'investissement"
                                        class="modal fade alt-list" :id="'modal' + infoalternative"
                                        tabindex="-1"
                                        role="dialog"
                                        aria-labelledby="alternatives"
                                        aria-hidden="true"
                                        :header-bg-variant="headerBgVariant"
                                        :header-text-variant="headerTextVariant"
                                        :body-bg-variant="bodyBgVariant"
                                        :body-text-variant="bodyTextVariant"
                                        :footer-bg-variant="footerBgVariant"
                                        :footer-text-variant="footerTextVariant"
                                        ok-only
                                        >
                                        <div>
                                            <p class="py-5 light-white-03 text-center">
                                                Si vous passiez sur Fortuneo, vous pourriez acheter <span class="font-weight-bold light-blue-01">{{ alt_fortuneo.name }}</span> et disposer d'actions dans le secteur <span class="font-weight-bold light-blue-01">{{ rec.sector.name_french }}</span>.
                                            </p>
                                        </div>
                                    </b-modal>
                                </div>
                                <div class="m-emphasis py-2">
                                    ISIN : {{ alt_fortuneo.ISIN_code }}
                                </div>
                                <div class="m-emphasis pb-2 fts-12">
                                    Frais : {{ alt_fortuneo.fees }} %
                                </div>
                                <div class="h-emphasis fts-12">
                                    Disponible sur Fortuneo
                                </div>
                            </div>
                            <div v-for="(alt_bourso, index4) in alternative.recommendations[index].alternatives_boursorama" :key="index4">
                                <div class="h-emphasis font-weight-bold">
                                    {{ alt_bourso.name }}
                                    <button style="background-color: transparent; border: none;" class="h-emphasis" v-b-modal="modalId(infoalternative)">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="mb-1 bi bi-info-circle" viewBox="0 0 16 16">
                                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                            <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                                        </svg>
                                    </button>
                                    <b-modal
                                        title="Ce titre est disponible sur une autre plateforme d'investissement"
                                        class="modal fade alt-list" :id="'modal' + infoalternative"
                                        tabindex="-1"
                                        role="dialog"
                                        aria-labelledby="alternatives"
                                        aria-hidden="true"
                                        :header-bg-variant="headerBgVariant"
                                        :header-text-variant="headerTextVariant"
                                        :body-bg-variant="bodyBgVariant"
                                        :body-text-variant="bodyTextVariant"
                                        :footer-bg-variant="footerBgVariant"
                                        :footer-text-variant="footerTextVariant"
                                        ok-only
                                        >
                                        <div>
                                            <p class="py-5 light-white-03 text-center">
                                                Si vous passiez sur Boursorama, vous pourriez acheter <span class="font-weight-bold light-blue-01">{{ alt_bourso.name }}</span> et disposer d'actions dans le secteur <span class="font-weight-bold light-blue-01">{{ rec.sector.name_french }}</span>.
                                            </p>
                                        </div>
                                    </b-modal>
                                </div>
                                <div class="m-emphasis py-2">
                                    ISIN : {{ alt_bourso.ISIN_code }}
                                </div>
                                <div class="m-emphasis pb-2 fts-12">
                                    Frais : {{ alt_bourso.fees }} %
                                </div>
                                <div class="h-emphasis fts-12">
                                    Disponible sur Boursorama
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <span class="l-emphasis">Pas de titres disponibles sur ce contrat</span>
                        </div>
                    </td>
                    <td class="p-3 text-left" style="vertical-align: middle;">
                        {{ rec.explanation }}
                    </td>
                    <td class="py-3 px-2" style="vertical-align: middle;">
                        {{ rec.time_horizon }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        props: [
            'alt_array',
            'token',
            'route',
        ],
        data() {
            return {
                alternative: this.alt_array[0],
                customs:[],
                variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark'],
                headerBgVariant: 'info',
                headerTextVariant: 'light',
                bodyBgVariant: 'dark',
                bodyTextVariant: 'dark',
                footerBgVariant: 'info',
                footerTextVariant: 'dark'
            }
        },

        mounted() {
            /* this.recos.forEach(rec =>
            {
                this.recs.push(rec);
            }); */
        },

        methods: {
            modalId(i) {
            return 'modal' + i;
            },

    }
}


</script>